Vue.component('userTeamProfile', {
    template: templates.userTeamProfile,
    props: ['team', 'show'],
    data() {
        return {
          // Add any local data properties here
        }
    },
    mounted() {
        const c = this;

    },
    watch: {
        team: function() {
            const c = this;
        }
    },
    methods: {
        select(team) {
            //card.selected = card.selected ? false : true;
        }
    }


})